import React, { useState, useEffect } from 'react';

import isPlainObject from 'lodash/isPlainObject';

import {
  LegacyBox,
  TextField,
  Checkbox,
  RadioGroup,
  RadioGroupOption,
} from '@gogame/components';
import { withFormField, FieldWrapper } from '@gogame/form';

import { TOP_DEPOSITORS } from 'scenes/CustomAudiences/Audiences/components/AudienceForm/DepositorsFieldSet/constants';
import { DEPOSITORS } from 'scenes/CustomAudiences/Audiences/components/AudienceForm/constants';

import { TOP_DEPOSITORS_NUMBER, TOP_DEPOSITORS_PERCENT } from './constants';

const FieldSet = ({ value = null, onChange, disabled }) => {
  const [isTopDepositors, setIsTopDepositors] = useState(
    !!(value && isPlainObject(value))
  );
  const [topDepositorType, setTopDepositorType] = useState(
    value && value.type ? value.type : TOP_DEPOSITORS_NUMBER
  );
  const [percentValue, setPercentValue] = useState(
    value && value.type && value.type === TOP_DEPOSITORS_PERCENT
      ? value.value
      : 0
  );
  const [numberValue, setNumberValue] = useState(
    value && value.type && value.type === TOP_DEPOSITORS_NUMBER
      ? value.value
      : 0
  );

  useEffect(() => {
    if (!disabled) {
      handleExternalChange();
    }
  }, [isTopDepositors, topDepositorType, percentValue, numberValue, disabled]);

  const handleInputNumberValue = (_e, inputValue) => {
    let numValue = inputValue ? parseFloat(inputValue) : 0;
    setNumberValue(numValue);
  };

  const handleInputPercentValue = (_e, inputValue) => {
    let numValue = inputValue ? parseFloat(inputValue) : 0;
    setPercentValue(numValue);
  };

  const handleChangeType = (_e, type) => {
    setTopDepositorType(type);
  };

  const handleTopDepositorsOnly = (_e, isDepositor) => {
    setIsTopDepositors(isDepositor);
  };

  const handleExternalChange = () => {
    let e = new CustomEvent('change');
    if (isTopDepositors) {
      let type = topDepositorType;
      const isNumberValue = topDepositorType === TOP_DEPOSITORS_NUMBER;
      const isPercentValue = topDepositorType === TOP_DEPOSITORS_PERCENT;

      if (isNumberValue) {
        onChange(e, {
          type: type,
          value: numberValue,
        });
      } else if (isPercentValue) {
        onChange(e, {
          type: type,
          value: percentValue,
        });
      }
    } else {
      onChange(e, undefined);
    }
  };

  return (
    <LegacyBox vertical={true}>
      <Checkbox
        label={'TOP depositors only'}
        onChange={handleTopDepositorsOnly}
        checked={isTopDepositors}
        disabled={disabled}
      />
      {isTopDepositors ? (
        <RadioGroup
          value={topDepositorType}
          vertical={true}
          onChange={handleChangeType}
          style={{ marginLeft: '16px' }}
          disabled={disabled}
        >
          <FieldWrapper padding={'16px 8px'}>
            <RadioGroupOption
              value={TOP_DEPOSITORS_NUMBER}
              label={
                <TextField
                  type={'number'}
                  label={'Depositors'}
                  placeholder={'0'}
                  width={'100px'}
                  onChange={handleInputNumberValue}
                  onClick={(e) => handleChangeType(e, TOP_DEPOSITORS_NUMBER)}
                  value={numberValue}
                />
              }
            />
          </FieldWrapper>
          <FieldWrapper padding={'16px 8px'}>
            <RadioGroupOption
              value={TOP_DEPOSITORS_PERCENT}
              label={
                <TextField
                  type={'number'}
                  label={'Depositors, %'}
                  placeholder={'0'}
                  width={'100px'}
                  onChange={handleInputPercentValue}
                  onClick={(e) => handleChangeType(e, TOP_DEPOSITORS_PERCENT)}
                  value={percentValue}
                />
              }
            />
          </FieldWrapper>
        </RadioGroup>
      ) : null}
    </LegacyBox>
  );
};

export default withFormField({
  name: `${DEPOSITORS}.${TOP_DEPOSITORS}`,
  padding: 0,
})(FieldSet);
